import React from 'react';
import { FieldLabel } from '../../../../components/Form';
import { DataModelerSelectTableColumn } from '../DataModelerFieldDropdown';
import {
  FieldType,
  ISchemaDataModelFieldsFragment,
  ITableColumnFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import {
  InstallTemporalsSectionDiv,
  RequiredFieldRow,
  TemporalCellDiv,
} from './DataModelerRequiredFieldsUI';
import { ITemporalTableColumnsDraftData } from '../../../../redux/slices/dataModeler';
import { SpacedConfigurationSeparator } from '../DataModelerCommonUI';
import { SquareRemoveButton, TextButton } from '../../../../components/Button';

interface IProps {
  schemaObj: ISchemaDataModelFieldsFragment;
  tableKey: string;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
  temporalsData: ITemporalTableColumnsDraftData | undefined;
  canEdit: boolean;
  canInit: boolean;
  canRemove: boolean;
  initInstallTemporals: (() => void) | null;
  removeInstallTemporals: (() => void) | null;
  setInstallDate: (tableColumn: ITableColumnFieldsFragment) => void;
  eventDateColumn: string | null;
}

const DataModelerInstallTemporalsSection = ({
  schemaObj,
  tableKey,
  availableColumnsFromServer,
  temporalsData,
  canEdit,
  canInit,
  initInstallTemporals,
  removeInstallTemporals,
  canRemove,
  setInstallDate,
  eventDateColumn,
}: IProps) => {
  return (
    <InstallTemporalsSectionDiv>
      {(canInit || !!temporalsData) && (
        <SpacedConfigurationSeparator layout="horizontal" size="full" />
      )}
      {canInit && !temporalsData && (
        <RequiredFieldRow $noTopGap={true}>
          <TextButton onClick={() => initInstallTemporals?.()}>
            + Set Install Date
          </TextButton>
        </RequiredFieldRow>
      )}
      {temporalsData && (
        <RequiredFieldRow $noTopGap={true}>
          <TemporalCellDiv>
            <FieldLabel>Install Date</FieldLabel>
          </TemporalCellDiv>
          <TemporalCellDiv>
            <DataModelerSelectTableColumn
              viewKey={schemaObj.fact.key}
              tableKey={tableKey}
              availableColumnsFromServer={availableColumnsFromServer}
              isDisabled={!canEdit}
              addFieldOnSetColumn={false}
              columnName={temporalsData.date.column ?? undefined}
              setColumn={setInstallDate}
              fieldTypeFilter={[FieldType.Date]}
              customFilter={(item) =>
                !eventDateColumn || item.column !== eventDateColumn
              }
            />
          </TemporalCellDiv>
          {canRemove && (
            <SquareRemoveButton
              onClick={() => removeInstallTemporals?.()}
              content={'Cancel'}
            />
          )}
        </RequiredFieldRow>
      )}
    </InstallTemporalsSectionDiv>
  );
};

export default DataModelerInstallTemporalsSection;
